module.exports = __webpack_public_path__ + "img/ic-smart-plus-plus.7deda7a0.svg";